import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

var swiper = new Swiper('.swiper-person', {
    slidesPerView: 2,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    loop: true,
    breakpoints: {
        // Configuración para versión móvil
        768: {
            slidesPerView: 5,
        },
    },
  });